// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"0cd8322a","984":"f109ce53"}[chunkId] + ".chunk.js";
};